import Vue from 'vue'
import Card from './Card'
import Child from './Child'
import Button from './Button'
import Checkbox from './Checkbox'
import Modal from './Modal'
import InternalError from '~/pages/errors/500.vue'

import {HasError, AlertError, AlertSuccess} from 'vform'

// Components that are registered globally.
[
    Modal,
    Card,
    Child,
    Button,
    Checkbox,
    HasError,
    AlertError,
    AlertSuccess,
    InternalError
].forEach(Component => {
    Vue.component(Component.name, Component)
})



// WEBPACK FOOTER //
// ./resources/assets/js/components/index.js